import { Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { countryOptions } from '@/module/Nomen/Country/model/CountryModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type CountrySelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CountrySelectControl<T extends FieldValues>(props: CountrySelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(countryOptions.getAll());
  const { t } = useTranslation();

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={(data ?? []).map(c => ({ id: c.id, name: c.name }))}
      description={t('countries.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('countries.select.nothingFound')}</Text>
        </Stack>
      }
      {...props}
    />
  );
}
